<template>
    <div>
      <div class="row d-none d-flex d-xl-none d-lg-none d-md-none">
          <div class="col-md-12 d-none d-block d-xl-none d-lg-none d-md-none">
            <div class="page-container md-layout-column">
                <md-toolbar class="md-primary">
                  <md-button class="md-icon-button" @click="showNavigation = true">
                    <md-icon>menu</md-icon>
                  </md-button>
                </md-toolbar>

                <md-drawer :md-active.sync="showNavigation" md-swipeable>
                  <md-toolbar class="md-transparent" md-elevation="0">
                      <div class="p-4" style="background:#309F5D;">
                      <div class="row">
                          <div class="col-md-12">
                              <img v-if="loggedUser.isFb==true" align="left" class="ml-1" width="50" style="height:55px;" :src="loggedUser.image" alt=""> 

                              <img v-if="loggedUser.isFb==false || loggedUser.isFb==null" align="left" class="ml-1" width="50" style="height:55px;" :src="loggedUser.image!=''? `https://qurbaniimages.s3.amazonaws.com/${replacer(loggedUser.image)}`:'img/dashboard/avatar.png'" alt=""> 
                          </div>
                          <div class="col-md-12 mt-2">
                              <span class="left-aligned ml-1 text-white" style="font-size:12px;display:block;">{{loggedUser.nickname}}</span>
                          </div>
                          <div class="col-md-12">
                            <span class="left-aligned ml-1 text-white text-mute" style="font-size:8px;display:block;">{{loggedUser.email!=null ? loggedUser.email:loggedUser.phoneno}} </span>
                          </div>

                      </div>
                  </div>
                    <!-- <span class="md-title">My App name</span> -->
                  </md-toolbar>

                  <md-list>
                     <md-list-item v-if="loggedUser.isFb==false" @click="active=10">
                      <md-icon><img src="img/dashboard/user.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Profile</span>
                    </md-list-item>
                    <md-list-item>
                      <md-icon><img src="img/dashboard/home.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Home</span>
                    </md-list-item>
                    <md-list-item @click="redirect(self,'/')">
                      <md-icon><img src="img/dashboard/dashboard_side.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Dashboard</span>
                    </md-list-item>
                    <md-list-item @click="active=2;showNavigation=false">
                      <md-icon><img src="img/dashboard/post-it.png" height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">My Ads</span>
                    </md-list-item>

                    <!-- <md-list-item >
                      <md-icon><img src="img/dashboard/langs.png" height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Change Language</span>
                    </md-list-item> -->

                    <md-list-item @click="active=4;showNavigation=false">
                      <md-icon><img src="img/dashboard/choices.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">My Order</span>
                    </md-list-item>

                    <md-list-item @click="active=5;showNavigation=false">
                      <md-icon><img src="img/dashboard/side-goat.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Sadqah Stock</span>
                    </md-list-item>
                    <md-list-item @click="showModal()" >
                      <md-icon><img src="img/dashboard/dslr-camera-white.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">New Post</span>
                    </md-list-item>
                   
                    <md-list-item @click="notificationCall();showNavigation=false">
                      <md-icon><img src="img/dashboard/bell.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Notifications </span>
                      <span v-if="chatUser.notifications!=null && hide==false">
                      <md-badge  v-if="chatUser.notifications.unviewed!=0"  class="md-error" :md-content="chatUser.notifications.unviewed" />
                      </span><!-- <md-badge v-else-if="chatUser.notifications.unviewed!=0 && chatUser.notifications!=null && hide==false" class="md-error" :md-content="chatUser.notifications.unviewed" /> -->
                    </md-list-item>
                    <md-list-item @click="active=9">
                      <md-icon><img src="img/dashboard/message.png" @click="active=9;showNavigation=false" height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Messages</span>
                    </md-list-item>
                    <md-list-item @click="logout">
                      <md-icon><img src="img/dashboard/logout.png"  height="20" alt=""></md-icon>
                      <span class="md-list-item-text text-white">Logout</span>
                    </md-list-item>
                  </md-list>
                </md-drawer>
                <md-content>
              <CDashboard v-if="active==1" @return-order="returnOrder"/>
              <CMyPosts :selected_post="selected_post" class="mt-5" v-if="active==2"/>
              <CMyOrders :order="order" class="mt-5" v-if="active==4" @return-order="returnOrder" />
              <CSadqahStock class="mt-5" v-if="active==5"  @order-item="orderItem"/>
              <CSadqahOrder :order="order" class="mt-5" v-if="active==6" @return-order="returnOrder" />
              <CSadqahOrderDetails :order="order" v-if="active==7" class="mt-5"/>
              <CMyNotifications  v-if="active==8" class="mt-5" @return-order="returnOrder" />
              <CMyMessages  v-if="active==9" class="mt-5"/>
              <CMyProfile v-if="active==10" class="mt-5"/>

                </md-content>

              </div>
          </div>
          
      </div>      
      <div class="row d-none d-md-flex">
          <div class="col-md-2">
              <div class="sidebar">
                  <div class="pl-4 pr-4 pt-2 pb-2"  style="background:#309F5D;">
                      <div class="row">
                          <div class="col-md-12">
                              <img v-if="loggedUser.isFb==true" align="left" class="ml-1" width="50" style="height:55px;" :src="loggedUser.image" alt=""> 

                              <img v-if="loggedUser.isFb==false || loggedUser.isFb==null" align="left" class="ml-1" width="50" style="height:55px;" :src="loggedUser.image!=''? `https://qurbaniimages.s3.amazonaws.com/${replacer(loggedUser.image)}`:'img/dashboard/avatar.png'" alt=""> 
                          </div>
                          <div class="col-md-12 mt-2">
                            
                              <span class="left-aligned ml-1 text-white" style="font-size:12px;display:block;">{{loggedUser.nickname}}</span>
                          </div>
                          <div class="col-md-12">
                            <span class="left-aligned ml-1 text-white text-mute" style="font-size:8px;display:block;">{{loggedUser.email!=null ? loggedUser.email:loggedUser.phoneno}} </span>
                          </div>
                      </div>
                  </div>
                  <div v-if="loggedUser.isFb==false" style="display:flex;" class="side-items" @click="active=10">
                      <img src="img/dashboard/user.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Profile </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="redirect(self,'/')">
                      <img src="img/dashboard/home.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Home </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="active=1">
                      <img src="img/dashboard/dashboard_side.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Dashboard </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="active=2">
                      <img src="img/dashboard/post-it.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>My Ads </span> </a>
                  </div>
                  <!-- <div style="display:flex;" class="side-items">
                      <img src="img/dashboard/langs.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Change Language </span> </a>
                  </div> -->
                  <div style="display:flex;" class="side-items" @click="active=4">
                      <img src="img/dashboard/choices.png"  class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>My Orders </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="active=5">
                      <img src="img/dashboard/side-goat.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#sadqah-stock"> <span>Sadqah Stock </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="active=11">
                      <img src="img/dashboard/ijtmae.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#sadqah-stock"> <span>Ijtmae Qurbani </span> </a>
                  </div>
                  <div style="display:flex;"  @click="showModal()"  class="side-items">
                      <img src="img/dashboard/dslr-camera-white.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>New Post </span> </a>
                  </div>
                  <div style="display:flex;position:relative" @click="notificationCall"  class="side-items">
                      <img src="img/dashboard/bell.png" class="mt-3 ml-3" style="height:21px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Notifications 
                        <span v-if="chatUser.notifications!=null && hide==false"  >
                        <b-badge v-if="chatUser.notifications.unviewed!=0" style="position: absolute;top: 0px;left: 1rem;" pill variant="danger">{{ this.chatUser.notifications.unviewed}} </b-badge> 
                        </span>
                      </span> </a>
                  </div>
                  <div style="display:flex;" @click="active=9"  class="side-items">
                      <img src="img/dashboard/message.png" class="mt-3 ml-3" style="height:21px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Messages </span> </a>
                  </div>
                  <div style="display:flex;" class="side-items" @click="logout">
                      <img src="img/dashboard/logout.png" class="mt-3 ml-3" style="height:23px !important;" alt="">
                      <a class="ml-1 pl-0 pr-0" href="#"> <span>Logout </span> </a>
                  </div>
              </div>
          </div>
          <div class="col-md-10 pl-0">
              <CDashboard v-if="active==1" @return-order="returnOrder"/>
              <CMyPosts :selected_post="selected_post"  class="mt-5" v-if="active==2"/>
              <CMyOrders :order="order" class="mt-5" v-if="active==4" @return-order="returnOrder" />
              <CSadqahStock class="mt-5" v-if="active==5"  @order-item="orderItem"/>
              <CSadqahOrder :order="order" class="mt-5" v-if="active==6" @return-order="returnOrder" />
              <CSadqahOrderDetails :order="order" v-if="active==7" class="mt-5" @return-order="returnOrder"/>
              <CMyNotifications  v-if="active==8" class="mt-5" @return-order="returnOrder"/>
              <CMyMessages  v-if="active==9" class="mt-5"/>
              <CMyProfile v-if="active==10" class="mt-5"/>
              <IjtmaeQurbaniOrder v-if="active==11" @return-order="returnOrder"/>
              <CIJtmaeOrderDetail  :order="order" v-if="active==12" class="mt-5" @return-order="returnOrder"/>

          </div>
      </div>
      <b-modal id="sell-dialog" hide-footer="" >
       <template v-slot:modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <h5>Upload your Ad</h5>
      <b-button size="sm" variant="outline-success" @click="close()">
        Cancel
      </b-button>
    </template>
        <div  style="display:flex;cursor:pointer;" @click="routeit('AUDIO')">
            <img src="img/sellmodal/dslr-camera.png" width="60" alt="">
            <h5 class="mt-3 ml-3">Upload Image</h5>
        </div>
        <div style="display:flex;cursor:pointer;" @click="routeit('VIDEO')" class="mb-4">
            <img src="img/sellmodal/video-camera.png" width="60" alt="">
            <h5 class="mt-3 ml-3">Upload Video</h5>
        </div>

  </b-modal>
    </div>
</template>
<script>
import CDashboard from '../components/CDashboard.vue'
import CMyPosts from '../components/CMyPosts.vue'
import CSadqahStock from '../components/CSadqahStock.vue'
import CSadqahOrder from '../components/CSadqahOrder.vue'
import CMyOrders from '../components/CMyOrders.vue'
import CMyNotifications from '../components/CMyNotifications.vue'
import CSadqahOrderDetails from '../components/CSadqahOrderDetails.vue'
import CMyMessages from '../components/CMyMessages.vue'
import CMyProfile from '../components/CMyProfile.vue'
import IjtmaeQurbaniOrder from '../components/IjtmaeQurbaniOrder.vue'
import CIJtmaeOrderDetail from '../components/CIJtmaeOrderDetail.vue'



import facebookLogin from 'facebook-login-vuejs'
import {mapGetters} from 'vuex'
import globalfuns from '../mixins/globalfuns'
import {RepositoryFactory} from '../Repository/RepositoryFactory'
const OrderRepository = RepositoryFactory.get('order_repository')
export default {
  name:'Dashboard',
  mixins:[globalfuns],
    components:{
        CDashboard,
        CMyPosts,
        CSadqahStock,
        CSadqahOrder,
        CMyOrders,
        CSadqahOrderDetails,
        facebookLogin,
        CMyNotifications,
        CMyMessages,
        CMyProfile,
        IjtmaeQurbaniOrder,
        CIJtmaeOrderDetail
    },
    props:['active_prop'],
    computed:{
        ...mapGetters(['user_notifications','chatUser','loggedUser','FB'])
    },
    watch:{
       loggedUser(){
        // Login for image to render on image upload
        
        this.$forceUpdate()

      }
    },
    data() {
      return {
         selected_post:null,
          active:1,
          hide:false,
          order:'',
          showNavigation: false,
          self:''
      }
    },
    created(){
      if(this.active_prop!=null){
        this.active=this.active_prop
      }
     this.self=this
    },
    methods:{
      notificationCall(){
        this.active=8;
        this.hide=true;
        this.$store.dispatch("updateNotifications",{id:this.loggedUser.id,viewed:this.user_notifications.length,unviewed:0})
      },  
      orderItem(item) {
          this.active=6
          this.order=item
      },
      returnOrder(arg){
        if(arg.type!=null){
          if(arg.type=='liked') {
          this.active=arg.value
          this.selected_post=arg.obj
          }
        }
        else{
          if(arg.item!=null){
          this.active=arg.id
          this.order=arg.item
          }
          else{
          this.active=arg
          }
        }
        
      },
      logout(){
        this.$store.dispatch("updateOnlineStatus",{id:this.loggedUser.id,status:false})

        this.$store.commit("logout",null)
        // if(this.loggedUser.isFb==true){
          this.FB.logout()
        // }
      },
      showModal(){
        this.$bvModal.show('sell-dialog')	
      },
      routeit(arg) { 
        this.type=arg
        this.$bvModal.hide('sell-dialog')
        this.$router.push({name:'NewPost',params:{type:arg}})
      },
    }
}
</script>

<style lang="scss" scoped>
  .page-container {
    min-height: 300px;
    overflow: hidden;
    position: relative;
    border: 1px solid rgba(#000, .12);
  }

   // Demo purposes only
  .md-drawer {
    width: 230px;
    max-width: calc(100vw - 125px);
  }

  .md-content {
    padding: 16px;
  }
</style>
<style scoped>


.card{
    border-radius: 1rem !important;
}
.card-body{
  padding:0.300rem !important;
}
.sidebar {
  margin: 0;
  padding: 0;
  width: 200px;
  background-color: #27A844;
  position: fixed;
  height: 100%;
  overflow: auto;
}
.sidebar a {
  display: block;
  color: white;
  padding: 16px;
  text-decoration: none;
}
 
.sidebar a.active {
 background-color: #388E3C;
  color: white;
  }
.side-items:hover{
  background-color: #388E3C;
  color: white;
}
/* .sidebar a:hover:not(.active) {
  background-color: #388E3C;
  color: white; */
/* } */
div.content {
  margin-left: 200px;
  padding: 1px 16px;
  height: 150%;
}
@media screen and (max-width: 700px) {
  .sidebar {
    width: 100%;
    height: auto;
    position: relative;
  }
  .sidebar a {float: left;}
  div.content {margin-left: 0;}
}
@media screen and (max-width: 400px) {
  .sidebar a {
    text-align: center;
    float: none;
  }
}
.md-toolbar.md-theme-default.md-transparent{
  padding:0rem !important
}

.md-toolbar.md-theme-default.md-primary{
  background:#27a844 !important
}
.md-drawer.md-theme-default {
  background:#27a844 !important

}
.md-list-item{
  background:#27a844 !important

}
.md-list.md-theme-default {
  padding-top:0rem !important;
  padding-bottom:0rem !important;

}

a{
  color:white !important;
}
</style>